export default "__VITE_ASSET__BQF_AXBA__"